/* eslint-disable max-len */
import React from 'react';
import {
  Box, Typography, Container, Paper, Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import Pipoheart from '../files/icons/Pipoheart';

function Cagnotte() {
  const { t } = useTranslation();

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '80vh',
      backgroundColor: 'background.default',
      py: 8,
      mt: 6,
    }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
            backgroundColor: 'background.paper',
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              mb: 4,
              color: 'terracota.main',
              fontWeight: 'medium',
            }}
          >
            {t('cagnotte.title')}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 4,
              color: 'text.secondary',
            }}
          >
            {`${t('cagnotte.greeting')}

${t('cagnotte.message')}

${t('cagnotte.description')}`}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 4,
            }}
          >
            <Button
              variant="outlined"
              href="https://www.onparticipe.fr/c/paulineetpierre"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                borderColor: 'terracota.main',
                borderWidth: 2,
                borderRadius: 2,
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
                textTransform: 'none',
                color: 'terracota.main',
                '&:hover': {
                  borderWidth: 2,
                  backgroundColor: 'terracota.light',
                  color: 'terracota.dark',
                },
              }}
              startIcon={<Pipoheart size={24} color="#D85314" />}
            >
              {t('cagnotte.button')}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default Cagnotte;
